import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';

export const CLIENT_DEFAULT_DATA = gql`
  query client($uri: String!) {
    client(uri: $uri) {
      id
      displayText
      defaultInvoicePaymentTerm
      invoiceTemplate {
        id
        displayText
      }
      taxProfile {
        id
        displayText
        description
        enabled
      }
      invoiceCurrency {
        id
        displayText
        symbol
      }
      billingContactInfo {
        address
        city
        country {
          id
          displayText
        }
        email
        faxNumber
        phoneNumber
        stateProvince
        website
        zipPostalCode
      }
      billingSettings {
        billLineItemsBy
        description
        internalNotes
        showComments
      }
    }
  }
`;

export const useClientDefaultData = ({ client }) => {
  const { id } = client || {};
  const { data, loading } = useQuery(CLIENT_DEFAULT_DATA, {
    variables: {
      uri: id
    },
    skip: !id,
    errorPolicy: 'all',
    fetchPolicy: 'network-only'
  });
  const clientDefaultData = get(data, 'client', null);

  return {
    clientDefaultData,
    loading
  };
};

export default useClientDefaultData;
